import vhCheck from "vh-check";
import { isTouch } from "./_helpers";
import { setDevice } from "./_utilities/devices";
import { setResizeEvent, setDeviceType } from "./utils";
import "./core";
import Carousels from "./_modules/carousels";
import InfiniteArticle from "./_modules/infinite-article";
import Header from "./_components/03-organisms/header-dropdown/header";
import HeaderMM from "./_components/03-organisms/header-megamenu/header-megamenu";
import Search from "./_components/03-organisms/search-dropdown/search";
import HeroCarousel from "./_components/03-organisms/hero-carousel";

vhCheck();

!isTouch && document.body.classList.add("no-touch");
isTouch && document.body.classList.add("is-touch");

// set resize custom event
setResizeEvent();
setDeviceType();
setDevice();

const _HEADER = new Header();
const _HEADERMM = new HeaderMM();
const _CAROUSELS = new Carousels();
const _INFINITEARTICLE = new InfiniteArticle();
const _SEARCH = new Search();
const _HEROCAROUSEL = new HeroCarousel();
